import React from "react";
import "./contact.css";

const Contact = () => {
  return (
    <div className="ct-wrapper">

      {/* ========== HERO SECTION ========== */}
      <section className="ct-hero">
        <h1>Let’s Connect</h1>
        <p>We’re here to help. Reach out and our team will get back to you shortly.</p>
      </section>

      {/* ========== MAIN CONTENT ========== */}
      <div className="ct-main">
        
        {/* ---- Contact Details ---- */}
        <div className="ct-card ct-details">
          <h3>Contact Information</h3>

          <div className="ct-info">
            <i className="fa-solid fa-phone"></i>
            <div>
              <h4>Call Us</h4>
              <p>+91 8800846929</p>
              <small className="ct-hours">Office hours: 10:00AM - 7:00PM</small>
            </div>
          </div>

          <div className="ct-info">
            <i className="fa-solid fa-envelope"></i>
            <div>
              <h4>Email</h4>
              <p>info@fundswalle.com</p>
              <small className="ct-hours">Office hours: 10:00AM - 7:00PM</small>
            </div>
          </div>

          <div className="ct-info">
            <i className="fa-solid fa-location-dot"></i>
            <div>
              <h4>Location</h4>
              <p>Office no. 304, Laxman Palace, Delhi</p>
              <small className="ct-hours">Office hours: 10:00AM - 7:00PM</small>
            </div>
          </div>
        </div>

        {/* ---- Contact Form ---- */}
        <div className="ct-card ct-form">
          <h3>Send a Message</h3>

          <form>
            <div className="ct-group">
              <label>Name</label>
              <input type="text" placeholder="Your full name" />
            </div>

            <div className="ct-group">
              <label>Email</label>
              <input type="email" placeholder="Your email" />
            </div>

            <div className="ct-group">
              <label>Message</label>
              <textarea rows="4" placeholder="Write your message..."></textarea>
            </div>

            <button className="ct-btn">Send Message</button>
          </form>
        </div>
      </div>

      {/* ========== MAP SECTION ========== */}
      <div className="ct-map">
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.761474122257!2d77.31459607528696!3d28.57692447569521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce45b22a79785%3A0xac760eff02b41b9a!2sWorld%20Trade%20Tower!5e0!3m2!1sen!2sin!4v1759321448244!5m2!1sen!2sin"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
